module.exports = __webpack_public_path__ + "static/media/talentsin_cn.ea4be9f5.png";